import { Component, OnInit, Input } from '@angular/core';
import { take } from 'rxjs/operators';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

import { Review, ReviewsResponse } from 'voxloud-types/dist/models/reviews';
import { ReviewsService } from 'src/app/domains/reviews/services';
import { Company } from 'src/app/domains/companies/models';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdateReviewPopupComponent } from 'src/app/features/reviews/components/update-review-popup/update-review-popup.component';
import { ReviewDetailsPopupComponent } from 'src/app/features/reviews/components';

@Component({
  selector: 'gdp-company-reviews',
  templateUrl: './company-reviews.component.html',
  styleUrls: ['./company-reviews.component.scss']
})
export class CompanyReviewsComponent implements OnInit {
  @Input() company: Company;
  public reviews: Review[];
  public loading: boolean = false;
  public pageSize: number = 10;
  public page: number = 0;
  public pagination = {
    page: 0,
    empty: true,
    totalPages: 0
  };
  public locale: string;
  constructor(
    private reviewsService: ReviewsService,
    private notification: NotificationService,
    private modalService: NgbModal,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.getReviews();
    this.locale = `${this.translate.currentLang}-${this.translate.currentLang.toUpperCase()}`;
    this.translate.onLangChange.subscribe((l: LangChangeEvent) => {
      this.locale = `${l.lang}-${l.lang.toUpperCase()}`;
    });
  }

  get loadingLinesArray() {
    return new Array(this.pageSize);
  }

  getReviews() {
    this.loading = true;
    this.reviewsService.getCompanyReviews(
      this.pagination.page,
      this.pageSize,
      this.company.companyId
    ).subscribe((response: ReviewsResponse) => {
      this.reviews = response.content;
      this.pagination = {
        page: response.pageable.pageNumber,
        empty: response.empty,
        totalPages: response.totalPages
      };
      this.loading = false;
    });
  }

  selectPageSize(event: number) {
    this.pageSize = event;
    this.pagination.page = 0;
    this.getReviews();
  }

  changeCurrentPage(event: number) {
    this.pagination = {
      ...this.pagination,
      page: event,
    }
    this.getReviews();
  }

  openDetailsReviewPopup(review: Review) {
    const modal = this.modalService.open(ReviewDetailsPopupComponent, {
      size: 'lg'
    });
    modal.componentInstance.review = review;
  }

  openUpdateReviewPopup(review: Review) {
    const modal = this.modalService.open(UpdateReviewPopupComponent, {
      size: 'md'
    });
    modal.componentInstance.review = review;

    modal.componentInstance.onAssigntoCompany.pipe(take(1)).subscribe(() => {
      this.getReviews();
      this.notification.success('company.reviews.notifications.success.updated');
    })
  }
}
